/**
 * Округляет число до переданного количества знаков после точки
 * @param {number} value
 * @param {number} decimals
 */
export const roundToDecimals = (value, decimals = 1) => {
  const multiplier = 10 ** decimals;
  return (
    Math.round(parseFloat((value / 1000).toString()) * multiplier) / multiplier
  );
};

// возвращает половину от числа, округленную в меньшую сторону
export const halfNumber = (num: number): number => Math.floor(num / 2);
